import { DefaultMantineColor, ThemeIcon, rem } from "@mantine/core"
import { icons } from "@tabler/icons-react"

export type IconType = keyof typeof icons

export function RenderIcon({
  icon,
  color,
}: {
  icon: IconType
  color: DefaultMantineColor
}) {
  const Icon = icons[icon]
  const themeIconSize = 28
  const remSize = 18
  if (Icon) {
    return (
      <ThemeIcon color={color} size={themeIconSize} radius="xl" variant="light">
        <Icon style={{ width: rem(remSize), height: rem(remSize) }} />
      </ThemeIcon>
    )
  }
  return null
}
